'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const hooks_useOverflow = require('../../../hooks/useOverflow.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_1mssy_1";
const content = "_content_1mssy_8";
const toggle = "_toggle_1mssy_21";
const styles = {
	root: root,
	content: content,
	toggle: toggle
};

const AlertDescription = ({ children, maxLines = 3 }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOverflowing, setOverflowingNode] = hooks_useOverflow.useOverflow();
  const toggle = isOverflowing && React__default.default.createElement("button", { className: styles.toggle, onClick: () => setIsOpen(!isOpen), type: "button", "data-zds": true }, isOpen ? "show less" : "show more");
  return React__default.default.createElement(
    "div",
    { className: styles.root, "data-zds": true },
    React__default.default.createElement(
      "div",
      { className: styles.content, "data-zds": true, ref: setOverflowingNode, style: {
        "--line-clamp": isOpen ? "initial" : maxLines
      } },
      React__default.default.createElement("div", { "data-zds": true }, children)
    ),
    toggle
  );
};

exports.AlertDescription = AlertDescription;
//# sourceMappingURL=AlertDescription.cjs.js.map
